module.exports = __webpack_public_path__ + "img/loading-power.13e7fd61.svg";